
class InputConstants {
    public static ProfileTitleLength = 40;
}

export {InputConstants};